import React, { useState, useContext } from 'react';

import TrackContext from '../../contexts/track-context';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { ReactComponent as Points } from '../../assets/vPoints.svg';

import {
  IconButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import FavoriteIcon from "@material-ui/icons/Favorite";
import UnFavoriteIcon from "@material-ui/icons/FavoriteBorderOutlined";
import DuplicateIcon from "@material-ui/icons/FileCopyOutlined";
import Helper from '../../services/helper';
import Constants from '../../services/constants';


function MobileAction(props) {
  let trackContext = useContext(TrackContext);
  const [showTrackModal, setShowTrackModal] = useState(false);

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleOptionClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl(null);
    setShowTrackModal(false);
  };
  // useEffect(() => {
  //   // console.log(props.mewoTrackId)
  // })
  const handleClose = () => {
    setShowTrackModal(false);
  }
  const handleProjectModal = (trackData) => {
    if (!trackContext.validateUser(Constants.ACTION.ADD_TO_PROJECT)) {
      trackContext.setShowSubscribePopup(true);
      trackContext.setUserAction(Constants.ACTION.ADD_TO_PROJECT);
      return;
    }

    trackContext.setTrackToBeAddedToProject(trackData);
    trackContext.setShowProjectModal(true);

  };

  return (
    <>
      <div
        className='flex justify-center  py-8 text-center w-10 sm:w-0 sm:hidden cursor-pointer'
        onClick={(e) => {
          setShowTrackModal(e.currentTarget);

        }}
      >
        <Points className='cursor-pointer' /> 
      </div>
      <Menu
        anchorEl={anchorEl}
        open={showTrackModal}
        onClose={handleClose2}
        PaperProps={{
          elevation: 4,
          style: {
            borderRadius: 10,
            paddingTop: 4,
            paddingBottom: 4,
            marginLeft: "-20px", // custom shift for spacing
            background: "rgb(var(--canvas))",
            // bottom: "10px",
            right: "30px",
            width: "60px"
          },
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={() => {
            props.handleAddTrackToFavorites(props.trackData);
            handleClose2();
          }}
        >
          <ListItemIcon>
            {props.favs?.indexOf(props.mewoTrackId) > -1 ? (
              <FavoriteIcon
                // fontSize="medium"
                className="text-red-600 self-center right-0 cursor-pointer hover:scale-110 transition-transform duration-200"
                style={{fontSize: "28px"}}
              />
            ) : (
              <UnFavoriteIcon
                // fontSize="medium"
                className="self-center right-0 cursor-pointer hover:text-red-600 transition-colors duration-200"
                style={{fontSize: "28px", color: "rgb(var(--text))"}}
              />
            )}
          </ListItemIcon>
        </MenuItem>
        <MenuItem
          onClick={() => { handleProjectModal({trackId : props.mewoTrackId, albumId : props.trackData?.album?.id, artworkRef : Helper.getArtworkURL(props.trackData?.album?.id), audioRef : Helper.playTrackURL(props.mewoTrackId)});
           handleClose2();}}
          >
          
          <ListItemIcon>
            <CreateNewFolderOutlinedIcon
              style={{ fontSize: "28px", color: "rgb(var(--text))" }}
              className="self-center right-0 cursor-pointer text-gray-700 block"
            />
          </ListItemIcon>
    
        </MenuItem> 
        
        <MenuItem
            onClick={(event) => {
              props.handleDownloadClick(event, props.mewoTrackId);
              handleClose2();
            }}
          >
          <ListItemIcon>
            <SaveAltIcon
              style={{ fontSize: "28px", color: "rgb(var(--text))" }}
              
            />
          </ListItemIcon>
        </MenuItem>
        <MenuItem 
          onClick={() => {
              handleClose2();
            }}>
          <ListItemIcon>
            <DuplicateIcon 
              onClick={(e) => props.duplicateTrack(props.trackObj, props.trackIndex)}
              style={{ fontSize: "28px", color: "rgb(var(--text))" }} />
          </ListItemIcon>
        </MenuItem>
        <MenuItem 
          onClick={() => {
              props.removeTrack(props.projectId,
                                props.projectTitle,
                                props.trackData?.title,
                                props.trackIndex);
              handleClose2();
            }}>
          <ListItemIcon>
            <DeleteIcon style={{ fontSize: "28px", color: "rgb(var(--text))" }} />
          </ListItemIcon>
        </MenuItem>
      </Menu>
      
    </>
  )
}

export default MobileAction;